'use strict'

const local = "http://localhost:3000"
const cpanel  = "https://fq.laason.mx"

exports.url = () =>{
     return `${cpanel}/api`;
}